import { useState, useEffect } from 'react';
import { Mail, Phone, Linkedin, Instagram } from 'lucide-react';
import API_BASE_URL from '../apiConfig';

const Footer = () => {
  const [settings, setSettings] = useState({
    email: 'teamvortexnce@gmail.com',
    phone: '+91 78922 04388',
    linkedinUrl: '#',
    instagramUrl: 'https://www.instagram.com/vortex_nce?igsh=MXM1djkybGdwaXc5bw==',
    copyrightYear: 2026,
  });

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/settings?t=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
    })
      .then(res => res.json())
      .then(data => {
        if (data) setSettings(data);
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <footer className="bg-[#050505] border-t border-white/5 py-10 sm:py-14 px-4 sm:px-6 relative z-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          {/* Logo */}
          <div className="mb-12">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <span className="text-3xl font-display font-bold gradient-text text-glow tracking-wider">
                TEAM VORTEX
              </span>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-12">
            <div className="flex items-center space-x-3 text-white">
              <div className="w-10 h-10 rounded-lg bg-vortex-blue/10 flex items-center justify-center border border-vortex-blue/20">
                <Mail className="h-5 w-5 text-vortex-blue" />
              </div>
              <span className="font-medium">{settings.email}</span>
            </div>
            <div className="flex items-center space-x-3 text-white">
              <div className="w-10 h-10 rounded-lg bg-vortex-orange/10 flex items-center justify-center border border-vortex-orange/20">
                <Phone className="h-5 w-5 text-vortex-orange" />
              </div>
              <span className="font-medium">{settings.phone}</span>
            </div>
          </div>

          {/* Social */}
          <div className="flex justify-center items-center space-x-6 mb-8">
            <a
              href={settings.linkedinUrl || '#'}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Team Vortex LinkedIn"
              className="w-12 h-12 rounded-full flex items-center justify-center bg-vortex-blue/10 border border-vortex-blue/30 hover:border-vortex-blue/70 hover:bg-vortex-blue/25 hover:scale-110 active:scale-95 transition-all duration-300 shadow-[0_0_15px_rgba(0,212,255,0.15)] group"
            >
              <Linkedin
                size={22}
                strokeWidth={2}
                className="text-vortex-blue group-hover:text-white transition-colors"
                style={{ color: '#00D4FF' }}
              />
            </a>
            <a
              href={settings.instagramUrl || 'https://www.instagram.com/vortex_nce'}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Team Vortex Instagram"
              className="w-12 h-12 rounded-full flex items-center justify-center bg-vortex-orange/10 border border-vortex-orange/30 hover:border-vortex-orange/70 hover:bg-vortex-orange/25 hover:scale-110 active:scale-95 transition-all duration-300 shadow-[0_0_15px_rgba(255,107,53,0.15)] group"
            >
              <Instagram
                size={22}
                strokeWidth={2}
                className="text-vortex-orange group-hover:text-white transition-colors"
                style={{ color: '#FF6B35' }}
              />
            </a>
          </div>

          <div className="text-white/40 text-sm">
            © {settings.copyrightYear} Team Vortex. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
